import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AlertWarningModule,
  ButtonModule,
  CheckboxStandardModule,
  FormAlertModule,
  HelpIconModule,
  InputModule
} from '@com-delta-idp/mnx-ui-kit';
import { LoginFooterModule } from '../../shared/login-footer/login-footer.module';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { LogoHeaderModule } from '../../shared/logo-header/logo-header.module';
import { LoginAuthenticationScreenComponent } from './login-authentication-screen.component';

@NgModule({
  declarations: [LoginAuthenticationScreenComponent],
  imports: [
    CommonModule,
    LoginHeaderModule,
    LoginFooterModule,
    LogoHeaderModule,
    InputModule,
    CheckboxStandardModule,
    HelpIconModule,
    ButtonModule,
    ReactiveFormsModule,
    AlertWarningModule,
    FormAlertModule
  ],
  exports: [
    LoginAuthenticationScreenComponent,
    LoginHeaderModule,
    LoginFooterModule,
    LogoHeaderModule
  ]
})
export class LoginAuthenticationScreenModule {}
